module.exports = __webpack_public_path__ + "img/4.2057b701.webp";